import {
  AllOtherPerilsDeductible,
  WindHailDeductible,
  WaterDamageDeductible,
  CoverageDLossOfUseValue,
  CoverageWaterDamageValue,
  CoverageELiabilityValue,
  CoverageFMedicalPaymentToOthersValue,
  CoverageInflationGuardValue,
  CoverageBoolean,
} from "@covertree/new-business-graphql";
import { formatCurrency } from "@covertree/utils";
import { GetValue } from "../../types";
import {
  mapDollarsEnumToNumber,
  mapPercentEnumToDisplayValue,
} from "../../../simpleMappings";
import { isEnumValue } from "../../utils";

const getHomeCoverageValueFormats: GetValue<number | string> = (value) =>
  value ? { value: formatCurrency(value) } : undefined;

const getHomeCoverageSettlementTypeValueFormats: GetValue<number | string> = (
  value
) =>
  value
    ? {
        prefix: "Settlment Type",
        value: formatCurrency(value),
      }
    : undefined;

const getOtherStructuresValueFormats: GetValue<number | string> = (value) =>
  value ? { value: formatCurrency(value) } : undefined;

const getOtherStructuresSettlementTypeValueFormats: GetValue<
  number | string
> = (value) =>
  value
    ? {
        prefix: "Settlment Type",
        value: formatCurrency(value),
      }
    : undefined;

const getYourBelongingsValueFormats: GetValue<number | string> = (value) =>
  value ? { value: formatCurrency(value) } : undefined;

const getYourBelongingsSettlementTypeValueFormats: GetValue<number | string> = (
  value
) =>
  value
    ? { prefix: "Settlment Type", value: formatCurrency(value) }
    : undefined;

const getStandardDeductibleValueFormats: GetValue<AllOtherPerilsDeductible> = (
  value
) => {
  if (!value) return undefined;

  let preparedValue = value;

  if (isEnumValue(value, AllOtherPerilsDeductible)) {
    preparedValue = formatCurrency(mapDollarsEnumToNumber(value));
  } else {
    preparedValue = formatCurrency(value);
  }

  return {
    value: preparedValue,
  };
};

const getWindHailValueFormats: GetValue<WindHailDeductible> = (value) => {
  if (!value) return undefined;

  let preparedValue = value;

  if (isEnumValue(value, WindHailDeductible)) {
    preparedValue = formatCurrency(mapDollarsEnumToNumber(value));
  } else {
    preparedValue = formatCurrency(value);
  }

  return {
    value: preparedValue,
  };
};

const getWaterDamageDeductibleValueFormats: GetValue<WaterDamageDeductible> = (
  value
) => {
  if (!value) return undefined;

  let preparedValue = value;

  if (isEnumValue(value, WaterDamageDeductible)) {
    preparedValue = formatCurrency(mapDollarsEnumToNumber(value));
  } else {
    preparedValue = formatCurrency(value);
  }

  return {
    value: preparedValue,
  };
};

const getLiabilityValueFormats: GetValue<CoverageELiabilityValue> = (value) => {
  if (!value) return undefined;

  let preparedValue = value;

  if (isEnumValue(value, CoverageELiabilityValue)) {
    preparedValue = formatCurrency(mapDollarsEnumToNumber(value));
  } else {
    preparedValue = formatCurrency(value);
  }

  return {
    value: preparedValue,
  };
};

const getLossOfUseValueFormats: GetValue<CoverageDLossOfUseValue> = (value) => {
  if (!value) return undefined;

  let preparedValue = value;

  if (isEnumValue(value, CoverageDLossOfUseValue)) {
    preparedValue = mapPercentEnumToDisplayValue(value);
  }

  if (typeof value === "number") {
    preparedValue = `${value}%`;
  }

  return {
    value: `${preparedValue}`,
  };
};

const getWaterDamageValueFormats: GetValue<CoverageWaterDamageValue> = (
  value
) => {
  if (!value) return undefined;

  if (isEnumValue(value, CoverageWaterDamageValue)) {
    return {
      value: mapPercentEnumToDisplayValue(value),
    };
  }

  if (typeof value === "number") {
    return {
      value: `${value}%`,
    };
  }

  return {
    value,
  };
};

const getInflationGuardValueFormats: GetValue<CoverageInflationGuardValue> = (
  value
) => {
  if (!value) return undefined;

  if (isEnumValue(value, CoverageInflationGuardValue)) {
    return {
      value: mapPercentEnumToDisplayValue(value),
    };
  }

  if (typeof value === "number") {
    return {
      value: `${value}%`,
    };
  }

  return {
    value,
  };
};

const getRoofPaymentScheduleValueFormats: GetValue<CoverageBoolean> = (
  value
) => (value ? { message: "Covered" } : undefined);

const getMedicalPaymentsValueFormats: GetValue<
  CoverageFMedicalPaymentToOthersValue
> = () => undefined;

export {
  getHomeCoverageValueFormats,
  getHomeCoverageSettlementTypeValueFormats,
  getOtherStructuresValueFormats,
  getOtherStructuresSettlementTypeValueFormats,
  getYourBelongingsValueFormats,
  getYourBelongingsSettlementTypeValueFormats,
  getStandardDeductibleValueFormats,
  getWindHailValueFormats,
  getWaterDamageDeductibleValueFormats,
  getLossOfUseValueFormats,
  getWaterDamageValueFormats,
  getLiabilityValueFormats,
  getMedicalPaymentsValueFormats,
  getInflationGuardValueFormats,
  getRoofPaymentScheduleValueFormats,
};
